import { http } from "./api-config";
import store from "../store";

const apiClient = http(process.env.VUE_APP_AGENDA_SERVICE);

export default {
    async getLcaFiscalTerms(report_type) {
        const res = await apiClient.get('/lca-fiscal-terms', { params: report_type })
        return res.data
    },
    async getLCACompanies(payload) {
        const res = await apiClient.get(`lca-company-names/`, { params: payload })
        return res.data
    },
    async getLCAData(payload) {
        const res = await apiClient.get(`lca-660`, { params: payload })
        return res.data
    },
    async getConsolidatedLCAData(payload) {
        const res = await apiClient.get(`lca-650`, { params: payload })
        return res.data
    },
    async createLCAData(payload) {
        const res = await apiClient.post(`lca-660`, payload)
        return res.data
    },
    async createConsolidatedData(payload) {
        const res = await apiClient.post(`lca-650`, payload)
        return res.data
    },
    async deleteLCARecords(report_type) {
        const res = await apiClient.delete(`lca`, { params: report_type })
        return res.data
    },
    async getMeetingByAgendaId(query, isLoadMore, initial) {
        let headers = {};
        if (!isLoadMore && !initial) {
            headers = { "isSilentAPI": true };
        }
        
        const queryString = new URLSearchParams(query).toString()
        const res = await apiClient.get(`agenda_meetings?${queryString}`, { headers });
        return res.data;
    },
    async getAgendaList(params) {
        if(!params){
            params = {}
        }
        let headers = {};
        if (JSON.stringify(store.state.variables.cashAgendaFilter) === JSON.stringify(params)) {
            headers = { "isSilentAPI": true };
        }
        store.commit('variables/setCashAgendaFilter', params)
        const res = await apiClient.get('agendalist', { params: params, headers })
        return res.data
    },
    async getAgendaListWithArchive(params) {
        const res = await apiClient.get('agendalist', { params: params })
        return res.data
    },
    async getAgendaById(id) {
        const res = await apiClient.get(`agenda/${id}`)
        return res.data
    },
    async createAgenda(agendaData) {
        const res = await apiClient.post('agenda', agendaData)
        return res.data
    },
    async updateAgenda(agendaData) {
        const res = await apiClient.put('agenda', agendaData)
        return res.data
    },
    async deleteAgenda(id) {
        const res = await apiClient.delete(`agenda/${id}`)
        return res.data
    },
    async getAgendaValidation(id) {
        const res = await apiClient.get(`validateagenda/${id}`)
        return res.data
    },
    async uploadMOMSignatureDocument(data) {
        const res = await apiClient.post('wansign_document_upload', data)
        return res.data
    },
    async sendMOMSignatureDocumentEmail(data) {
        const res = await apiClient.post('wansign_document_send_email', data)
        return res.data
    },
    async momSignatureDocumentStatus(meetingId) {
        const res = await apiClient.get(`wansign_document_status/${meetingId}`)
        return res.data
    },
    async momSignatureDocumentDownload(meetingId, filename) {
        try {

            const res = await apiClient.get(`wansign_document_download/${meetingId}`, {
                responseType: "blob",
                fileName: filename,
            })
            return res
        } catch (error) {
            let responseResult = await error.response.data.text();
            const responseObj = JSON.parse(responseResult)
            const firstDigitStr = String(error.response.status)[0];
            if (Number(firstDigitStr) === 4) {
                myApp.$store.commit('setAPIErrorMessage', responseObj.error_message)
            }
            return Promise.reject(error);
        }

    },
    async createMeetingChat(data) {
        const res = await apiClient.post('meetingchat', data)
        return res.data
    },
    async updateMeetingChat(data) {
        const res = await apiClient.put('meetingchat', data)
        return res.data
    },
    async listMeetingChatsAndComments(meetingId) {
        const res = await apiClient.get(`meetingchats/${meetingId}`)
        return res.data
    },
    async chatParticipants(meetingId) {
        const res = await apiClient.get(`chat_participants/${meetingId}`)
        return res.data
    },
    async storeChatComment(data) {
        const headers = { "Content-Type": "multipart/form-data" };
        const res = await apiClient.put("meetingcomment", data, {
          headers,
        });
        return res.data;
      },
      async updateChatComment(data) {
        const headers = { "Content-Type": "multipart/form-data" };
        const res = await apiClient.put("meetingcomment", data, {
          headers,
        });
        return res.data;
      },
      async deleteMeetingChat(id) {
        const res = await apiClient.delete(`meetingchat/${id}`);
        return res.data;
      },

      async meetingChatComment(data) {
        const res = await apiClient.put('meetingcomment', data)
        return res.data
    },
    async listMeetingChatComments(chat_id) {
        const res = await apiClient.get(`chatmessages/${chat_id}`)
        return res.data
    },
    async addMeetingMessage(data) {
        const headers = { "Content-Type": "multipart/form-data" };
        const res = await apiClient.post("chatmessage", data, {
          headers,
        });
        return res.data;
      },

      async saveChatMessageForm(data) {
        const headers = { "Content-Type": "multipart/form-data" };
        const res = await apiClient.post("chatmessage", data, {
          headers,
        });
        return res.data;
      },
      async updateMeetingMessage(data) {
        const headers = { "Content-Type": "multipart/form-data" };
        const res = await apiClient.put("chatmessage", data, {
          headers,
        });
        return res.data;
      },
      async deletechatmessage(params) {
        const res = await apiClient.put('deletechatmessage', params);
        return res.data;
      },
      async getObservers(meetingTypeId) {
        const res = await apiClient.get(`observers/${meetingTypeId}`)
        return res.data
    },
}